import { Icon } from "@iconify/react";
import { enabledMenuItems, orgName } from "@utils/Constants";
import { Divider, Layout, Menu, MenuProps, Typography } from "antd";
import moment from "moment";
import { ReactElement, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { getCurrentModule } from "~/Utils/StringConstants";
import styles from "./Navbar.module.scss";

const { Footer } = Layout;
const { Text, Title } = Typography;

const getIcon: any = (icon: string, rotate = 0) => (
  <Icon
    icon={icon}
    className={styles.navbarItemIcon}
    inline
    rotate={rotate}
  />
);

type NavItem = {
  icon: ReactElement;
  label: string;
  key: string;
  locked?: boolean;
  roles: string[];
};

type AntMenuItem = Required<MenuProps>["items"][number];

interface MenuItem extends NavItem {
  childrens?: NavItem[];
}

interface Props {
  collapsed: boolean;
}

export const Navbar = ({ collapsed }: Props) => {
  const { hasPermissions, hasRole } = useHasAccess();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [user] = useLocalStorage("user", null);
  const [currentAirport] = useLocalStorage("currentAirport", null);

  const navigate = useNavigate();
  const currentModule = getCurrentModule();
  console.log("currentModulesssss", currentModule);

  function getItem({
    roles,
    label,
    key,
    icon,
    children,
    locked,
    checkRole = true,
    module,
  }: {
    roles: string[];
    label: React.ReactNode;
    key?: React.Key | null;
    icon?: React.ReactNode;
    children?: AntMenuItem[];
    locked?: boolean;
    checkRole?: boolean;
    module?: string;
  }): AntMenuItem | null {
    const roleMatchesModule =
      module === "[*]" &&
      roles.some((role) => {
        let rolePrefix = role.split("_")[0];
        if (role.startsWith("PASSENGER_ECMS")) {
          rolePrefix = "PASSENGER ECMS";
        } 
        // else if (role.startsWith("PASSENGER")) {
        //   rolePrefix = "PASSENGER BUTTERFLY EFFECT";
        // } 
        else if (role === "MAHB_CORPORATE_CREATOR" || role === "MAHB_CORPORATE_REVIEWER") {
          rolePrefix = "CORPORATE";
        }
        return rolePrefix === currentModule;
      });
    const isSuperAdminOnly = roles.length === 1 && roles[0] === "SUPER_ADMIN";
    const canAccess = (module === currentModule || roleMatchesModule || isSuperAdminOnly) && hasRole(roles);
    // ((currentModule === module || module === '[*]') && hasRole(roles))
    console.log("canAccesssss", canAccess, currentModule, module, hasRole(roles));
    if (canAccess) {
      return {
        key,
        icon,
        children,
        label,
        ...(locked && { disabled: true }),
      } as AntMenuItem;
    }
    return null;
  }

  const primaryItems: AntMenuItem[] = [
    getItem({
      roles: ["SUPER_ADMIN", "MAGP_REVIEWER", "MAGP_CREATOR"],
      label: "Dashboard",
      key: `/dedicated/magp/dashboard`,
      icon: getIcon("ant-design:appstore-outlined"),
      module: "MAGP",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAGP_CREATOR"],
      label: "Announcements",
      key: `/dedicated/magp/announcements`,
      icon: getIcon("grommet-icons:announce"),
      module: "MAGP",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAGP_CREATOR"],
      label: "Manual",
      key: `/dedicated/magp/manual?activeTab=manualWelcomePage`,
      icon: getIcon("ic:outline-poll"),
      module: "MAGP",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAGP_CREATOR"],
      label: "FAQs",
      key: `/dedicated/magp/faq`,
      icon: getIcon("wpf:faq"),
      module: "MAGP",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAGP_REVIEWER"],
      label: "MAGP Access Management",
      key: `/dedicated/magp/access-management?activeTab=pendingUsers`,
      icon: getIcon("hugeicons:time-management-circle"),
      module: "MAGP",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAGP_CREATOR"],
      label: "Popup",
      key: `/dedicated/magp/popup?activeTab=cameraAccess`,
      icon: getIcon("entypo:popup"),
      module: "MAGP",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAGP_CREATOR"],
      label: "Login",
      key: `/dedicated/magp/login?activeTab=mobileLoginPage`,
      icon: getIcon("ri:login-box-line"),
      module: "MAGP",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAGP_CREATOR"],
      label: "Profile",
      key: `/dedicated/magp/profile?activeTab=userProfileSettings`,
      icon: getIcon("streamline:user-profile-focus-solid"),
      module: "MAGP",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAGP_CREATOR"],
      label: "Others",
      key: `/dedicated/magp/others?activeTab=welcomePageForCalendar`,
      icon: getIcon("material-symbols-light:other-admission-outline-rounded"),
      module: "MAGP",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAGP_CREATOR"],
      label: "Gallery",
      key: `/dedicated/magp/gallery`,
      icon: getIcon("material-symbols:photo-library-rounded"),
      module: "MAGP",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAGP_CREATOR"],
      label: "Contact Directory",
      key: `/dedicated/magp/contact-directory?activeTab=CposOffice`,
      icon: getIcon("ic:baseline-description"),
      module: "MAGP",
    }),

    // (currentAirport === "klia1" || currentAirport === "klia2")
    //   ? getItem({
    //       roles: ["SUPER_ADMIN", "PASSENGER_CREATOR", "PASSENGER_REVIEWER"],
    //       label: "Butterfly Effect",
    //       key: `/dedicated/passenger/butterfly-effect?activeTab=pending`,
    //       icon: getIcon("icon-park-outline:butterfly"),
    //       module: "PASSENGER",
    //     })
    //   : null,
    getItem({
      roles: ["SUPER_ADMIN", "PASSENGER_CREATOR", "PASSENGER_REVIEWER"],
      label: "Butterfly Effect",
      key: `/dedicated/passenger/butterfly-effect?activeTab=pending`,
      icon: getIcon("icon-park-outline:butterfly"),
      module: "PASSENGER BUTTERFLY EFFECT",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "PASSENGER_ECMS_CREATOR"],
      label: "Homepage",
      key: `/dedicated/passenger/homepage`,
      icon: getIcon("mdi:home-outline"),
      module: "PASSENGER ECMS",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "PASSENGER_ECMS_CREATOR"],
      label: "Flight Information",
      key: `/dedicated/passenger/flight-information`,
      icon: getIcon("mdi:airplane"),
      module: "PASSENGER ECMS",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "PASSENGER_ECMS_CREATOR"],
      label: "Shop & Dine",
      key: `/dedicated/passenger/shopAndDine`,
      icon: getIcon("iconoir:shop"),
      module: "PASSENGER ECMS",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "PASSENGER_ECMS_CREATOR"],
      label: "Mobile App",
      key: `/dedicated/passenger/mobileapp`,
      icon: getIcon("mdi:cellphone"),
      module: "PASSENGER ECMS",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "PASSENGER_ECMS_CREATOR"],
      label: "Maps",
      key: `/dedicated/passenger/maps`,
      icon: getIcon("mdi:map-outline"),
      module: "PASSENGER ECMS",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "PASSENGER_ECMS_CREATOR"],
      label: "Navigation",
      key: `/dedicated/passenger/navigation?activeTab=passengerHeader&subActiveTab=mainheaders`,
      icon: getIcon("famicons:navigate-circle-outline"),
      module: "PASSENGER ECMS",
    }),
    // getItem({
    //   roles: ["SUPER_ADMIN", "PASSENGER_CREATOR"],
    //   label: "Help",
    //   key: `/dedicated/passenger/help`,
    //   icon: getIcon("material-symbols:help-outline-rounded"),
    //   module: "PASSENGER",
    // }), - help commented before
    // getItem({
    //   roles: ["SUPER_ADMIN", "PASSENGER_CREATOR"],
    //   label: "Header",
    //   key: `/dedicated/passenger/header`,
    //   icon: getIcon("mdi:page-layout-header"),
    //   module: "PASSENGER",
    // }),- header commented before
    // getItem({
    //   roles: ["SUPER_ADMIN", "PASSENGER_CREATOR"],
    //   label: "Footer",
    //   key: `/dedicated/passenger/footer`,
    //   icon: getIcon("mdi:page-layout-footer"),
    //   module: "PASSENGER",
    // }), - footer commented before
    getItem({
      roles: ["SUPER_ADMIN", "MAHB_CORPORATE_CREATOR"],
      label: "Homepage",
      key: `/dedicated/corporate/homepage?activeTab=homePageBanner`,
      icon: getIcon("line-md:home"),
      module: "CORPORATE",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAHB_CORPORATE_CREATOR"],
      label: "Corporate Profile",
      key: `/dedicated/corporate/corporate-profile`,
      icon: getIcon("pajamas:profile"),
      module: "CORPORATE",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAHB_CORPORATE_CREATOR"],
      label: "Organization",
      key: `/dedicated/corporate/organization?activeTab=boardOfDirectors`,
      icon: getIcon("fluent:organization-48-regular"),
      module: "CORPORATE",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAHB_CORPORATE_CREATOR"],
      label: "Corporate Integrity",
      key: `/dedicated/corporate/corporate-integrity`,
      icon: getIcon("fluent:building-32-regular"),
      module: "CORPORATE",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAHB_CORPORATE_CREATOR"],
      label: "Subsidiaries",
      key: `/dedicated/corporate/subsidiaries?activeTab=subsidiariesPageHeading`,
      icon: getIcon("fluent-mdl2:secondary-nav"),
      module: "CORPORATE",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAHB_CORPORATE_CREATOR"],
      label: "Awards",
      key: `/dedicated/corporate/awards?activeTab=awardsPageHeading`,
      icon: getIcon("gg:awards"),
      module: "CORPORATE",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAHB_CORPORATE_CREATOR"],
      label: "Business Opportunities",
      key: `/dedicated/corporate/business-oppurtunities?activeTab=airlineServices&subActiveTab=airlineServicesFacilities&thirdChildActiveTab=airlineServicesFacilitiesPageHeading`,
      icon: getIcon("ic:outline-business-center"),
      module: "CORPORATE",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAHB_CORPORATE_CREATOR"],
      label: "Stake Holders",
      key: `/dedicated/corporate/stakeholders?activeTab=agencies`,
      icon: getIcon("carbon:partnership"),
      module: "CORPORATE",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAHB_CORPORATE_CREATOR"],
      label: "Malaysia Airport Academy",
      key: `/dedicated/corporate/training-academy`,
      icon: getIcon("healthicons:i-training-class-24px"),
      module: "CORPORATE",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAHB_CORPORATE_CREATOR"],
      label: "Media Center",
      key: `/dedicated/corporate/media-centre`,
      icon: getIcon("mingcute:file-line"),
      module: "CORPORATE",
    }),
    // getItem({
    //   roles: ["SUPER_ADMIN", "MAHB_CORPORATE_CREATOR"],
    //   label: "Malaysia Airport Academy",
    //   key: `/dedicated/corporate/malaysiaairportacademy`,
    //   icon: getIcon("healthicons:i-training-class-24px"),
    //   module: 'CORPORATE'
    // }),
    // getItem({
    //   roles: ["SUPER_ADMIN", "MAHB_CORPORATE_CREATOR"],
    //   label: "Sustainbility",
    //   key: `/dedicated/corporate/sustainbility`,
    //   icon: getIcon("hugeicons:sustainable-energy"),
    //   module: "CORPORATE",
    // }),
    getItem({
      roles: ["SUPER_ADMIN", "MAHB_CORPORATE_CREATOR"],
      label: "Contact us",
      key: `/dedicated/corporate/contactus`,
      icon: getIcon("pixelarticons:contact-plus"),
      module: "CORPORATE",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAHB_CORPORATE_CREATOR"],
      label: "Navigation",
      key: `/dedicated/corporate/navigation?activeTab=webAppFooter&subActiveTab=aboutAndLegal`,
      icon: getIcon("famicons:navigate-circle-outline"),
      module: "CORPORATE",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "ERAMAN_CREATOR"],
      label: "Dashboard",
      key: `/dedicated/eraman/dashboard`,
      icon: getIcon("ri:dashboard-line"),
      module: "ERAMAN",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "ERAMAN_CREATOR"],
      label: "Product Management",
      key: `/dedicated/eraman/product-management?activeTab=products`,
      icon: getIcon("grommet-icons:package"),
      module: "ERAMAN",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "ERAMAN_REVIEWER"],
      label: "Feedback Submissions",
      key: `/dedicated/eraman/feedback-submissions?activeTab=enquiries`,
      icon: getIcon("ri:file-paper-2-line"),
      module: "ERAMAN",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "ERAMAN_CREATOR"],
      label: "Newsletter Subscription",
      key: `/dedicated/eraman/newsletterSubscription?activeTab=guestUsers`,
      icon: getIcon("ri:group-line"),
      module: "ERAMAN",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "ERAMAN_REVIEWER"],
      label: "EPC Applications",
      key: `/dedicated/eraman/epc-applications`,
      icon: getIcon("ri:money-dollar-box-line"),
      module: "ERAMAN",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "ERAMAN_CREATOR"],
      label: "Advertisement",
      key: `/dedicated/eraman/advertisement?activeTab=campaign`,
      icon: getIcon("ri:radio-line"),
      module: "ERAMAN",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "ERAMAN_CREATOR"],
      label: "Pages",
      key: `/dedicated/eraman/pages?activeTab=aboutEraman&subActiveTab=aboutUs`,
      icon: getIcon("grommet-icons:book"),
      module: "ERAMAN",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "ERAMAN_CREATOR"],
      label: "Store Locations",
      key: `/dedicated/eraman/storeLocations`,
      icon: getIcon("lucide:store"),
      module: "ERAMAN",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "ERAMAN_CREATOR"],
      label: "Header",
      key: `/dedicated/eraman/header?activeTab=topHeader`,
      icon: getIcon("ri:layout-top-line"),
      module: "ERAMAN",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "ERAMAN_CREATOR"],
      label: "Footer",
      key: `/dedicated/eraman/footer?activeTab=socialMediaIcons`,
      icon: getIcon("ri:layout-bottom-line"),
      module: "ERAMAN",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "ERAMAN_CREATOR"],
      label: "Configuration",
      key: `/dedicated/eraman/configuration?activeTab=notificationSettings`,
      icon: getIcon("ri:settings-3-line"),
      module: "ERAMAN",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "ERAMAN_CREATOR"],
      label: "Contents",
      key: `/dedicated/eraman/contents?activeTab=eramanSignIn`,
      icon: getIcon("fluent:content-view-28-regular"),
      module: "ERAMAN",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "ERAMAN_REVIEWER"],
      label: "Product Reviews",
      key: `/dedicated/eraman/product-reviews?activeTab=pending`,
      icon: getIcon("ri:chat-quote-line"),
      module: "ERAMAN",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAGP_CREATOR", "ERAMAN_CREATOR", "MAHB_CORPORATE_CREATOR", "PASSENGER_CREATOR", "PASSENGER_ECMS_CREATOR"],
      label: "Status Information",
      key: `/dedicated/status-information?activeTab=draft`,
      icon: getIcon("grommet-icons:status-info"),
      module: "[*]",
    }),
    // COMMENTED APPROVAL MANAGEMENT
    getItem({
      roles: ["MAGP_REVIEWER", "SUPER_ADMIN"],
      label: "Approval Management",
      key: `/dedicated/magp/approval-management?activeTab=pending`,
      icon: getIcon("hugeicons:validation-approval"),
      module: "MAGP",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "ERAMAN_REVIEWER"],
      label: "Approval Management",
      key: `/dedicated/eraman/approval-management?activeTab=pending`,
      icon: getIcon("hugeicons:validation-approval"),
      module: "[*]",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "MAHB_CORPORATE_REVIEWER"],
      label: "Approval Management",
      key: `/dedicated/corporate/approval-management?activeTab=pending`,
      icon: getIcon("hugeicons:validation-approval"),
      module: "CORPORATE",
    }),
    getItem({
      roles: ["MAGP_REVIEWER"],
      label: "MAGP User Management",
      key: `/dedicated/magp/user-management?activeTab=activeUsers`,
      icon: getIcon("fluent-mdl2:workforce-management"),
      module: "MAGP",
    }),
    // getItem({
    //   roles: ["PASSENGER_REVIEWER"],
    //   label: "Passenger User Management",
    //   key: `/dedicated/passenger/user-management?activeTab=activeUsers`,
    //   icon: getIcon("fluent-mdl2:workforce-management"),
    //   module: "PASSENGER",
    // }),
    getItem({
      roles: ["SUPER_ADMIN", "PASSENGER_ECMS_REVIEWER"],
      label: "Approval Management",
      key: `/dedicated/passenger/approval-management?activeTab=pending`,
      icon: getIcon("hugeicons:validation-approval"),
      module: "PASSENGER ECMS",
    }),
    // getItem({
    //   roles: ["ERAMAN_REVIEWER"],
    //   label: "Eraman User Management",
    //   key: `/dedicated/eraman/user-management?activeTab=activeUsers`,
    //   icon: getIcon("fluent-mdl2:workforce-management"),
    //   module: "ERAMAN",
    // }),

    //CENTRALIZED
    getItem({
      roles: ["SUPER_ADMIN", "CENTRALIZED_CREATOR"],
      label: "Modules",
      key: `/centralized/centralizedModules`,
      icon: getIcon("material-symbols:multiple-airports-outline-rounded"),
      module: "CENTRALIZED",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "CENTRALIZED_CREATOR"],
      label: "Banner",
      key: `/centralized/centralizedBanner`,
      icon: getIcon("line-md:home"),
      module: "CENTRALIZED",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "CENTRALIZED_CREATOR"],
      label: "Policies",
      key: `/centralized/privacyPolicy`,
      icon: getIcon("mdi:shield-key"),
      module: "CENTRALIZED",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "CENTRALIZED_CREATOR"],
      label: "FAQs",
      key: `/centralized/centralizedFaqs`,
      icon: getIcon("wpf:faq"),
      module: "CENTRALIZED",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "CENTRALIZED_CREATOR"],
      label: "Airline Tail Image",
      key: `/centralized/centralizedAirlineTailImage`,
      icon: getIcon("mingcute:airplane-line"),
      module: "CENTRALIZED",
    }),
    // getItem({
    //   roles: ["SUPER_ADMIN", "CENTRALIZED_CREATOR"],
    //   label: "Traveller's Info",
    //   key: `/centralized/centralizedTravellersInfo`,
    //   icon: getIcon("ic:outline-business-center"),
    //   module: "CENTRALIZED",
    // }),
    getItem({
      roles: ["SUPER_ADMIN", "CENTRALIZED_CREATOR"],
      label: "Baggage Guide",
      key: `/centralized/centralizedBaggageGuide`,
      icon: getIcon("ic:outline-business-center"),
      module: "CENTRALIZED",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "CENTRALIZED_CREATOR"],
      label: "Lags & Restricted Items",
      key: `/centralized/centralizedLagsAndRestrictedItems`,
      icon: getIcon("material-symbols:luggage-outline"),
      module: "CENTRALIZED",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "CENTRALIZED_CREATOR"],
      label: "Shop & Dine",
      key: `/centralized/centralizedShopAndDine`,
      icon: getIcon("iconoir:shop"),
      module: "CENTRALIZED",
    }),
    // getItem({
    //   roles: ["SUPER_ADMIN", "CENTRALIZED_CREATOR"],
    //   label: "Promotions",
    //   key: `/centralized/centralizedPromotions`,
    //   icon: getIcon("ep:promotion"),
    //   module: "CENTRALIZED",
    // }),
    getItem({
      roles: ["SUPER_ADMIN", "CENTRALIZED_CREATOR"],
      label: "Promotions",
      key: `/centralized/centralizedPromotion`,
      icon: getIcon("hugeicons:promotion"),
      module: "CENTRALIZED",
    }),

    getItem({
      roles: ["SUPER_ADMIN", "CENTRALIZED_CREATOR"],
      label: "Status Information",
      key: `/centralized/status-information?activeTab=draft`,
      icon: getIcon("grommet-icons:status-info"),
      module: "CENTRALIZED",
    }),
    getItem({
      roles: ["SUPER_ADMIN", "CENTRALIZED_REVIEWER"],
      label: "Approval Management",
      key: `/centralized/approval-management`,
      icon: getIcon("hugeicons:validation-approval"),
      module: "CENTRALIZED",
    }),
    // getItem({
    //   roles: ["CENTRALIZED_REVIEWER"],
    //   label: "Centralized User Management",
    //   key: `/centralized/user-management?activeTab=activeUsers`,
    //   icon: getIcon("fluent-mdl2:workforce-management"),
    //   module: "CENTRALIZED",
    // }),
    getItem({
      roles: ["SUPER_ADMIN"],
      label: "User Management",
      key: `/user-management?activeTab=activeUsers`,
      icon: getIcon("fluent-mdl2:workforce-management"),
      module: "[*]",
    }),
  ];

  const getOpenKeys = () => {
    const keys: any = [];

    primaryItems.find((o: any) =>
      o?.key === pathname
        ? keys.push(o.key)
        : o?.children?.find((c: any) => (c?.key === pathname ? keys.push(o.key) : null))
    );

    return keys;
  };

  const getPrimaryActiveKey = () => {
    let result = "";
    const basePath = pathname.split("?")[0]; // Get the base path without query parameters

    primaryItems.forEach((primary: any) => {
      const primaryBasePath = primary && primary.key && primary.key.split("?")[0]; // Get the base path of the primary key without query parameters

      if (basePath.includes(primaryBasePath)) {
        result = primary.key;
      } else {
        primary &&
          primary.children?.forEach((child: any) => {
            const childBasePath = child.key.split("?")[0]; // Get the base path of the child key without query parameters
            if (basePath.includes(childBasePath)) {
              result = child.key;
            }
          });
      }
    });
    return result;
  };

  // const getSecondaryActiveKey = () => {
  //   let result = "";
  //   secondaryItems.map((secondary: any) => {
  //     secondary?.key.split("/")[1]?.split("?")[0] === pathname.split("/")[1]
  //       ? (result = secondary.key)
  //       : secondary?.children?.map((child: any) => (child.key === pathname ? (result = child.key) : ""));
  //   });
  //   return result;
  // };

  return (
    <Layout
      style={{
        background: styles.white,
        height: "100%",
        paddingTop: 12,
        overflowY: "auto",
        overflowX: "hidden",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Menu
        selectable
        mode="inline"
        items={primaryItems.filter((item: any) => item && enabledMenuItems.includes(item.label))}
        style={{
          background: styles.white,
        }}
        className={styles.navBar}
        defaultOpenKeys={getOpenKeys()}
        selectedKeys={[getPrimaryActiveKey()]}
        onClick={({ key }) => {
          if (key === "nocloud") {
            return false;
          } else {
            navigate(key);
          }
        }}
      />
      <div>
        <span className={styles.divider}>
          <Divider style={{ marginBlock: styles.whitespace3 }} />
        </span>
        {/*<Menu*/}
        {/*  selectable*/}
        {/*  mode="inline"*/}
        {/*  items={secondaryItems.filter((item: any) => item && enabledMenuItems.includes(item.label))}*/}
        {/*  style={{*/}
        {/*    background: styles.primary,*/}
        {/*  }}*/}
        {/*  defaultOpenKeys={getOpenKeys()}*/}
        {/*  selectedKeys={[getSecondaryActiveKey()]}*/}
        {/*  className={styles.navBar}*/}
        {/*  onClick={({ key }) => key && navigate(key)}*/}
        {/*/>*/}
        {!collapsed && (
          <Footer className={styles.footerStyle}>
            <Title
              level={5}
              style={{ color: styles.white }}
            >
              &copy; {orgName} {moment().format("YYYY")}
            </Title>
          </Footer>
        )}
      </div>
    </Layout>
  );
};
